import styled from "styled-components";

export const ModalPreparacionContainer = styled.div`
  padding: 24px 48px;
`;
export const ModalPreparacionHeader = styled.div``;
export const ModalPreparacionBody = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 20px;
  max-height: 500px;
  max-width: 720px;
  .EtiquetaAutorizacion {
    background-color: var(--color-latex30);
    height: 34px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 26px;
    width: max-content;
    padding: 0 20px;
    color: var(--color-white);
    user-select: none;
  }
`;
export const ModalPreparacionSubBody = styled.div`
  display: flex;
  align-items: center;
  .ModalPreparacion-txtPreparacion {
    overflow: hidden;
    max-height: 378px;
  }
`;

export const ModalPreparacionFooter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  padding-top: 24px;
`;
export const ModalPreparacionBtn = styled.div`
  background-color: ${({ cerrar }) =>
    cerrar ? " var(--color-grey65)" : " var(--color-latex10)"};
  border-radius: 8px;
  color: var(--color-white);
  width: 220px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;
export const ModalPreparacionBtnCerrar = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ cerrar }) =>
    cerrar ? " var(--color-grey65)" : " var(--color-latex10)"};
  width: 182px;
  height: 40px;
  border-radius: 8px;
  background: none;
  border: 1px solid var(--color-latex30);
  color: var(--color-latex30);
  font-size: 16px;
  font-weight: 500;
  box-shadow: 0 100px 80px rgb(0 0 0 / 7%),
    0 41.7776px 33.4221px rgb(0 0 0 / 5%), 0 22.3363px 17.869px rgb(0 0 0 / 4%),
    0 12.5216px 10.0172px rgb(0 0 0 / 4%), 0 6.6501px 5.32008px rgb(0 0 0 / 3%),
    0 2.76726px 2.21381px rgb(0 0 0 / 2%);
`;

export const FiltroCascadaScrollContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 200px;
`;
export const ScrollUpButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(props) =>
    props.disabled
      ? "var(--color-grey65)"
      : props.opcDelete
      ? "var(--color-primary)"
      : "var(--color-latex30)"};
  cursor: pointer;
  color: var(--color-white);
  font-size: 24px;
  border-radius: 50%;
  width: 52px;
  height: 52px;
  transform: rotate(-90deg);
`;
export const ScrollDownButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(props) =>
    props.disabled
      ? "var(--color-grey65)"
      : props.opcDelete
      ? "var(--color-primary)"
      : "var(--color-latex30)"};
  cursor: pointer;
  color: var(--color-white);
  font-size: 24px;
  border-radius: 50%;
  width: 52px;
  height: 52px;
  transform: rotate(90deg);
`;
